export default __webpack_public_path__ + "static/media/log-out.3a123abd.svg";